module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--connect-3-f911012d.png";